import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { take } from 'rxjs/operators';
import { TooltipComponent } from 'apps/account/src/account-shared/dialogs/tooltip/tooltip.component';
import { UrlFormatter } from 'shared';
import { ShortUrlService } from '../short-urls.service';
import { ContestInviteSetupOptions } from './setup-options';

@Component({
    selector: 'ft-short-url-wizard',
    templateUrl: './short-url-wizard.component.html',
    styleUrls: ['./short-url-wizard.component.css'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShortUrlWizardComponent {
  @Input() params: ContestInviteSetupOptions;
  @Output() done: EventEmitter<any> = new EventEmitter();
  wI = 0;
  data: any = {};
  submitted = false;

  error = false;
  errorMessage = '';

  /** Swaps the confirmation tooltip for the Ctrl+C fallback wording. */
  copyFailed = false;

  private readonly cdr = inject(ChangeDetectorRef);

  constructor(
    private shortUrls: ShortUrlService
  ) { }

  onCopied(tooltip: TooltipComponent) {
    this.copyFailed = false;
    tooltip.show();
  }

  onCopyFailed(tooltip: TooltipComponent) {
    // The directive has selected the link, so the user can still finish the copy by hand.
    this.copyFailed = true;
    tooltip.show();
  }

  err(message: string) {
    this.submitted = false;
    this.error = true;
    this.errorMessage = message;
    // All three are rendered, and this runs from a subscribe ERROR callback. The HTTP error path
    // does notify via the PendingTask, so this is belt-and-braces today — but the notification
    // would be lost the moment this method is reached from anywhere else, and the audit cannot
    // tell the two callers apart (FTK-7588).
    this.cdr.markForCheck();
  }

  saveStep() {
    this.submitted = true;
    this.shortUrls
      .createShortUrl(
        this.params.companyCode,
        this.params.propertyUuid,
        this.data.url,
        this.data.displayName,
        this.data.shortUrl,
        this.params.contestUuid,
        this.params.theme
      )
      .pipe(take(1))
      .subscribe(
        () => this.done.emit(this.data),
        (err: any) => {
          this.err(err.error);
        }
      );
  }

  destUrlStep() {
    if (!this.data.destinationUrl) {
      this.data.url = UrlFormatter.format(
        this.params.baseUrl,
        {
          utm_source: 'flipto',
          utm_medium: 'referral',
          utm_campaign: 'broadcast'
        },
        true
      );
    } else {
      this.data.url = UrlFormatter.appendStringToQuery(this.params.baseUrl, this.data.destinationUrl);
    }

    this.continue();
  }

  continue() {
    this.wI++;
    this.submitted = false;
    this.error = false;
    this.errorMessage = '';
  }

  previousStep() {
    this.submitted = false;
    if (this.wI > 0) { this.wI--; }
  }

}
